export default __webpack_public_path__ + "static/media/logo2.182f7250.png";